module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['ReportModifier']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module ReportModifier URL not available') },
        init: (arg) => { throw new Error('Module ReportModifier URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['ReportModifier'].get(request),
      init: (arg) => {
        try {
          return window['ReportModifier'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: ReportModifier')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module ReportModifier not available') },
      init: (arg) => { throw new Error('Module ReportModifier not available') }
    })
    document.head.appendChild(script);
  });